import { useMutation } from 'react-apollo'
import { AddPartnerProjectPackage } from '../../../graphql/packages/mutations'

/**
 *  Add a package to a partner project

 * @returns Package
 */

export const useMutationAddPartnerProjectPackageApi = () => {
  const [
    addPartnerProjectPackage,
    {
      data: addPartnerProjectPackageData,
      error: addPartnerProjectPackageError,
      loading: addPartnerProjectPackageLoading,
    },
  ] = useMutation(AddPartnerProjectPackage, {})

  return [
    addPartnerProjectPackage,
    {
      data: addPartnerProjectPackageData,
      error: addPartnerProjectPackageError,
      loading: addPartnerProjectPackageLoading,
    },
  ] as const
}
